// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.GMI,
  is_online: true,
  data_git_repo: 'https://r.laurente:7rcuhnsouheecfv2dfmlkpo43lkkfwdutoanqpz23ru72ci6lz7a@dev.azure.com/AnalyticSmart/DevOps/_git/Merchandising-Data-Gmi',
  assets_url: 'https://stmerchandisingdevgmi.blob.core.windows.net/gmi-assets',
  local_db_name: 'merchandising.db',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
